
import { getAuth, sendPasswordResetEmail, fetchSignInMethodsForEmail, verifyPasswordResetCode, confirmPasswordReset } from 'firebase/auth';
import { AuthResult } from './types';

// Send password reset email
export const sendPasswordReset = async (email: string): Promise<AuthResult> => {
  try {
    const auth = getAuth();
    
    // First check if the email exists in Firebase Auth
    const methods = await fetchSignInMethodsForEmail(auth, email);
    
    if (methods && methods.length > 0) {
      await sendPasswordResetEmail(auth, email);
      return { 
        success: true,
        message: 'Password reset email sent'
      };
    } else {
      return {
        success: false,
        error: 'No account exists with this email address'
      };
    }
  } catch (error: any) {
    console.error('Password reset error:', error);
    return {
      success: false,
      error: error.message || 'Failed to send password reset email'
    };
  }
};

// Check if password reset code is valid
export const checkPasswordResetCode = async (code: string): Promise<AuthResult> => {
  try {
    const auth = getAuth();
    await verifyPasswordResetCode(auth, code);
    return { success: true };
  } catch (error: any) {
    console.error('Reset code validation error:', error);
    return {
      success: false,
      error: error.message || 'Invalid or expired reset code'
    };
  }
};

// Complete password reset with new password
export const resetPasswordWithCode = async (code: string, newPassword: string): Promise<AuthResult> => {
  try {
    const auth = getAuth();
    await confirmPasswordReset(auth, code, newPassword);
    return { success: true };
  } catch (error: any) {
    console.error('Password reset error:', error);
    return {
      success: false,
      error: error.message || 'Failed to reset password'
    };
  }
};
